import React from 'react';
import {Col, Form, InputGroup} from 'react-bootstrap';
import Accordion from 'react-bootstrap/Accordion';
import {useTranslation} from "react-i18next";
import {useAccordionToggle} from 'react-bootstrap/AccordionToggle';
import i18n from 'i18next';
import { DateTime } from 'luxon';
import { luxonLocale } from '../localeUi.js';
import './FilterWrap.css';

class FilterForm extends React.Component {

  handleChangeMinDays = (res) => {
    this.props.handleChangeMinDays(res);
  };

  handleChangeMaxDays = (res) => {
    this.props.handleChangeMaxDays(res);
  };

  handleChangeStartingMonth = (res) => {
    this.props.handleChangeStartingMonth(res);
  };

  render() {
    const months = Array.from({ length: 12 }, (_, mm) => ({
      id: mm,
      name: DateTime.now().plus({ months: mm }).setLocale(luxonLocale(i18n.language)).toFormat('LLLL'),
    })).map((mon) => (
      <option key={mon.id} value={mon.id}>{mon.name}</option>
    ));

    return (
      <div>
        <Form.Row controlid="FilterForm.days" className="filter-row">
          <Form.Label className='text-muted text-left filter-text text-small' column sm="4">
            {i18n.t('filters.tripLength')} {i18n.t('filters.from')}
          </Form.Label>
          <Col sm="3">
            <InputGroup className="">
              <Form.Control type="number"
                            placeholder="1"
                            className="select-day"
                            aria-describedby="from-days"
                            value={this.props.MinDays}
                            onChange={this.handleChangeMinDays}/>
              <InputGroup.Append>
                <InputGroup.Text id="from-days">{i18n.t('filters.days')}</InputGroup.Text>
              </InputGroup.Append>
            </InputGroup>
          </Col>
          <Form.Label className='text-muted text-left filter-text text-small' column sm="0.5">{i18n.t('filters.to')}</Form.Label>
          <Col sm="3">
            <InputGroup className="">
              <Form.Control type="number"
                            placeholder="15"
                            className="select-day"
                            value={this.props.MaxDays}
                            onChange={this.handleChangeMaxDays}
                            aria-describedby="to-days"/>
              <InputGroup.Append>
                <InputGroup.Text sm="0.5" id="to-days">{i18n.t('filters.days')}</InputGroup.Text>
              </InputGroup.Append>
            </InputGroup>
          </Col>
        </Form.Row>
        <Form.Row>
          <Form.Label className='text-muted text-left filter-text text-small' sm="4" column>{i18n.t('filters.startFrom')}</Form.Label>
          <Col sm={3}>
            <Form.Control
              as="select"
              value={this.props.StartingMonth}
              onChange={this.handleChangeStartingMonth}>
              {months}
            </Form.Control>
          </Col>
          <Col sm={0.5}/>
          <Col sm={3}/>
        </Form.Row>
      </div>
    );
  }
}


function CustomToggle({props, children, eventKey}) {
  const DecoratedOnClick = useAccordionToggle(eventKey); /*, () =>
    console.log("")
  );*/
  const {t, i18n} = useTranslation();

  const onChangeCheck = (event) => {
    let checked = event.target.checked;

    if (!checked) {
      props.handleChangeMinDays({target: {name: "", value: 1}});
      props.handleChangeMaxDays({target: {name: "", value: 15}});
      props.handleChangeStartingMonth({target: {name: "", value: 0}});
    }
  };

  return (
    <div className="filter-panel__toggle">
      <Form.Check className="filters-style"
                  label={i18n.t('advanced filters')}
                  type="checkbox"
                  id="inline-checkbox-1"
                  onChange={onChangeCheck}
                  onClick={DecoratedOnClick}/>
    </div>
  );
}

class FilterWrap extends React.Component {
  render() {
    return (
      <div className="filter-panel">

        <Accordion className="filter-panel__accordion">
          <CustomToggle props={this.props} eventKey="1"/>
          <Accordion.Collapse eventKey="1">
            <div className="filter-panel__body">
            <FilterForm handleChangeMinDays={this.props.handleChangeMinDays} MinDays={this.props.MinDays}
                        handleChangeMaxDays={this.props.handleChangeMaxDays} MaxDays={this.props.MaxDays}
                        handleChangeStartingMonth={this.props.handleChangeStartingMonth}
                        StartingMonth={this.props.StartingMonth}
            />
            </div>
          </Accordion.Collapse>
        </Accordion>

      </div>
    );
  }
}

export default FilterWrap;
